export default class CurrentShop {
    public isDaiberShop() {
        return document.body.classList.contains('portal');
    }

    public isPromoPage() {
        return document.body.classList.contains('promo');
    }

    public isMobile() {
        return document.body.classList.contains('mobile') || document.body.classList.contains('account-mobile');
    }

    public isDaiberAccountArea() {
        return document.documentElement.classList.contains('daiber-account-area');
    }
}
